<div class="button-right">
  <button *ngFor="let btn of options" matButton="tonal" (click)="btn.action()"  
    [disabled]="btn.disabled?.asObservable() | async"
    [hidden]="btn.hidden?.asObservable() | async"
    [matTooltip]="btn.label | translate">
    {{ btn.label | translate }}
  </button>
</div>